module.exports = __webpack_public_path__ + "static/media/download.68b011bf.svg";